import { IBorrower } from '@app/models/borrower.model';
import { IProposal } from '@app/models/proposal.model';
import * as _moment from 'moment';

const moment = _moment;

export function updateHubData({
  borrower,
  loanData,
  vehicle
}: IProposal): void {
  const localHubData = JSON.parse(sessionStorage.getItem('hubData'));
  if (borrower) {
    localHubData['AcctNum'] = borrower.accountNumber;
    localHubData['FirstName'] = borrower.firstName;
    localHubData['LastName'] = borrower.lastName;
    localHubData['Address1'] = borrower.address1;
    localHubData['Address2'] = borrower.address2;
    localHubData['City'] = borrower.city;
    localHubData['State'] = borrower.state
      ? borrower.state.toUpperCase()
      : borrower.state;
    localHubData['Phone'] = borrower.phoneNumber;
    localHubData['EmailAddress'] = borrower.emailAddress;
    localHubData['Zip'] = borrower.zipCode;
    localHubData['DateOfBirth'] = moment(borrower.dateOfBirth)?.format(
      'YYYY-MM-DD'
    );
    localHubData['COBFirstName'] = borrower.coBorrower?.firstName;
    localHubData['COBLastName'] = borrower.coBorrower?.lastName;
    localHubData['CoBorrowerDOB'] = borrower.coBorrower?.dateOfBirth;
  }
  if (loanData) {
    localHubData['LoanNum'] = loanData.loanNumber;
    localHubData['OtherFees'] = loanData.otherFees;
    localHubData['DownPayment'] = loanData.deductions;
    localHubData['PaymentsPerYear'] = loanData.paymentsPerYear;
    localHubData['LoanDate'] = moment(loanData.loanDate)?.format('YYYY-MM-DD');
    localHubData['FirstPaymentDate'] = moment(
      loanData.firstPaymentDate
    )?.format('YYYY-MM-DD');
    localHubData['PurchasePrice'] = loanData.amountFinanced;
    localHubData['Rate'] = loanData.interestRate;
    localHubData['InsName'] = loanData.insName;
    localHubData['InsPolicyNumber'] = loanData.insPolicyNumber;
    localHubData['InsAgent'] = loanData.insAgent;
    localHubData['InsAgentPhone'] = loanData.insAgentPhone;
    localHubData['Term'] = loanData.totalMonths || loanData.termInMonths;
    localHubData['ReferralCode'] = loanData.referralCode;
  }
  if (vehicle) {
    localHubData['VIN'] = vehicle.vin ? vehicle.vin.toUpperCase() : vehicle.vin;
    localHubData['VehicleYear'] = vehicle.year;
    localHubData['VehicleMake'] = vehicle.make;
    localHubData['VehicleModel'] = vehicle.model;
    localHubData['VehicleStyle'] = vehicle.style;
    localHubData['VehicleMakeCode'] = vehicle.makeCode;
    localHubData['VehicleModelCode'] = vehicle.modelCode;
    localHubData['VehicleStyleCode'] = vehicle.styleCode;
    localHubData['Odometer'] = vehicle.odometer;
    localHubData['MockVin'] = vehicle.mockVin;
    localHubData['collateralType'] = vehicle['collateralType'];
    localHubData['collateralCode'] = vehicle['collateralCode'];
    localHubData['VehiclePurchasePrice'] = vehicle['purchasePrice'] || 0;
    localHubData['RetailPrice'] = vehicle['retailPrice'] || 0;
    localHubData['IsVehicleNotFound'] = !!vehicle.isVehicleNotFound;
    localHubData['ValidateVin'] = !!vehicle['validateVin'];
  }
  sessionStorage.setItem('hubData', JSON.stringify(localHubData));
}

export function updateHubBorrowerData(borrower: IBorrower): void {
  const localHubData = JSON.parse(sessionStorage.getItem('hubData'));
  localHubData['AcctNum'] = borrower.accountNumber;
  localHubData['FirstName'] = borrower.firstName;
  localHubData['LastName'] = borrower.lastName;
  localHubData['Address1'] = borrower.address1;
  localHubData['Address2'] = borrower.address2;
  localHubData['City'] = borrower.city;
  localHubData['State'] = borrower.state
    ? borrower.state.toUpperCase()
    : borrower.state;
  localHubData['Phone'] = borrower.phoneNumber;
  localHubData['EmailAddress'] = borrower.emailAddress;
  localHubData['Zip'] = borrower.zipCode;
  localHubData['DateOfBirth'] = moment(borrower.dateOfBirth)?.format(
    'YYYY-MM-DD'
  );
  localHubData['COBFirstName'] = borrower.coBorrower?.firstName;
  localHubData['COBLastName'] = borrower.coBorrower?.lastName;
  localHubData['CoBorrowerDOB'] = borrower.coBorrower?.dateOfBirth;
  sessionStorage.setItem('hubData', JSON.stringify(localHubData));
}

/**
 * Check if Express is just launched with LosId (retrieve quote for Meridian Link with just username/password/losId)
 * @param localHubData {{key: string, value: string | number | null}}
 */
export function checkEmptyHubData(localHubData: {
  key: string;
  value: string | number | null;
}): boolean {
  let isEmpty: boolean = true;
  // List of Hub Props to check against to make sure they have no data
  const localHubItemsToCheck: string[] = [
    'AcctNum',
    'FirstName',
    'LastName',
    'Address1',
    'Address2',
    'City',
    'State',
    'Zip',
    'Phone',
    'EmailAddress',
    'DateOfBirth',
    'VehicleYear',
    'VIN',
    'Odometer',
    'VehicleMake',
    'VehicleModel',
    'VehicleStyle',
    'PurchasePrice',
    'DownPayment',
    'LoanDate',
    'FirstPaymentDate',
    'LoanNum',
    'Rate',
    'Term',
    'OtherFees',
    'VehiclePurchasePrice',
    'RetailPrice'
  ];
  for (const prop of Object.keys(localHubData)) {
    if (
      localHubItemsToCheck.includes(prop) &&
      localHubData[prop] !== 0 &&
      localHubData[prop] !== null &&
      localHubData[prop] !== undefined &&
      localHubData[prop] !== ''
    ) {
      isEmpty = false;
    }
  }
  return isEmpty;
}
